// Closure para hacer debounce en una función
export function debouncerFn<T = any>(miliseconds: number, callback: Function) {
  let timer: number | null = null;

  return (...args: T[]) => {
    if (timer !== null)
      clearTimeout(timer);

    timer = window.setTimeout(() => {
      timer = null;
      callback(...args);
    }, miliseconds);
  };
};
